/* jshint esversion: 6 */

///////////////////////////////////////////////////////////////////
// CONFIG
// Enter all icons here, and
//  add them to the library
//  in the install method below
///////////////////////////////////////////////////////////////////

import { faTimes, faPaperPlane, faExternalLinkAlt, faSpinner } from '@fortawesome/free-solid-svg-icons';

///////////////////////////////////////////////////////////////////
// END CONFIG
///////////////////////////////////////////////////////////////////

// import animation for fonts
// look for animation examples here
// http://l-lin.github.io/font-awesome-animation/
// ENABLE THIS IF YOU WANT ANIMATIONS
//require("@/assets/vendor/fontawesome/font-awesome-animation.min.css");

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
	install(Vue) {
		library.add(faExternalLinkAlt, faTimes, faPaperPlane, faSpinner);
		Vue.component('font-awesome-icon', FontAwesomeIcon);
	}
};
